import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { AutoReleaseDialogTitle, ERROR_LIST_COLORS, OrdersResultList, SUCCESS_LIST_COLORS } from "./AutoReleaseDialogParts";

const ResultSection = ({ icon, color, title, children, mb }) => (
  <Box mb={mb}>
    <Box display="flex" alignItems="center" gap={1} mb={1.5}>
      {icon}
      <Typography fontWeight={700} color={color}>
        {title}
      </Typography>
    </Box>
    {children}
  </Box>
);

// Outcome of an auto-release: which orders were released and which failed.
const ReleaseResultsDialog = ({ result, onClose }) => {
  const released = result.released || [];
  const failed = result.failed || [];
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth dir="rtl" PaperProps={{ sx: { borderRadius: 3 } }}>
      <AutoReleaseDialogTitle title="תוצאות שחרור אוטומטי" />
      <DialogContent sx={{ p: 3 }}>
        {released.length > 0 && (
          <ResultSection
            icon={<CheckCircleIcon sx={{ color: "#217346", fontSize: 18 }} />}
            color="#217346"
            title={`שוחררו ${released.length} הזמנות`}
            mb={failed.length > 0 ? 2 : 0}
          >
            <OrdersResultList orders={released} separator=" → " detail={(r) => r.newStatus} colors={SUCCESS_LIST_COLORS} />
          </ResultSection>
        )}
        {failed.length > 0 && (
          <ResultSection icon={<CancelIcon sx={{ color: "#dc2626", fontSize: 18 }} />} color="#dc2626" title={`נכשלו ${failed.length} הזמנות`}>
            <OrdersResultList orders={failed} detail={(r) => r.reason} colors={ERROR_LIST_COLORS} />
          </ResultSection>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{ bgcolor: "#0054A5", color: "#fff", borderRadius: 2, px: 3, "&:hover": { bgcolor: "#003d7a" } }}
        >
          סגור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReleaseResultsDialog;
